import URLParse from "url-parse";

/**
 * Vyvolání mc pluginu pro načtení certifikátů.
 *
 * @param requestId unikátní identifikátor požadavku
 * @param url cesta k serveru
 */
export function loadCertificates(requestId: string, url: string = getUrl()) {
    const call = 'marbessign:list|' + requestId + '|' + url;
    console.log(call);

    return get(requestId, call);
}

/**
 * Vyvolání mc pluginu pro podepisování.
 *
 * @param requestId  unikátní identifikátor požadavku
 * @param thumbprint otisk certifikátu pro podepisování
 * @param url url cesta k serveru
 */
export function signDocumentFile(requestId: string, thumbprint: string, url: string = getUrl()) {
    const call = 'marbessign:multisign|' + requestId + '|' + url + '|' + thumbprint;
    console.log(call);
    return get(requestId, call);
}

/**
 * Získání url adresy serveru.
 */
export function getUrl(): string {
    const serverContextPath = (window as any).serverContextPath;
    const p = new URLParse(serverContextPath);
    return p.origin + serverContextPath;
}

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

function get(id, url) {
    return new Promise((resolve, reject) => {
        const frameId = "getFrame-" + id;

        if (document.getElementById(frameId)) {
            return reject();
        }

        const downloadFrame = document.createElement('iframe');
        downloadFrame.src = url;
        downloadFrame.id = frameId;
        downloadFrame.style.display = "none";
        window.document.body.appendChild(downloadFrame);

        resolve(null);
    });
}
